// Small, round inclusions follow the membrane with lag and resolve mutual contact.
export class BeadCluster {
  constructor(centers,radii){
    this.rest=centers.map(p=>[...p]);this.radii=[...radii];this.reset();
  }
  reset(){this.positions=this.rest.map(p=>[...p]);this.velocity=this.rest.map(()=>[0,0,0]);this.activity=0;this.contact=0;}
  step(elapsed,targets){
    if(!Number.isFinite(elapsed)||elapsed<=0)return;
    const h=Math.min(elapsed,1/30)/2;this.contact=0;this.activity=0;
    for(let sub=0;sub<2;sub++){
      const previous=this.positions.map(p=>[...p]);
      for(let i=0;i<this.positions.length;i++)for(let a=0;a<3;a++){
        this.velocity[i][a]=(this.velocity[i][a]+(targets[i][a]-this.positions[i][a])*95*h)*Math.exp(-13*h);
        this.positions[i][a]+=this.velocity[i][a]*h;
      }
      for(let iteration=0;iteration<3;iteration++){
        for(let i=0;i<this.positions.length;i++)for(let j=i+1;j<this.positions.length;j++){
          const p=this.positions[i],q=this.positions[j],dx=q[0]-p[0],dy=q[1]-p[1],dz=q[2]-p[2];
          const squared=dx*dx+dy*dy+dz*dz,minimum=this.radii[i]+this.radii[j];
          if(squared>=minimum*minimum)continue;
          const distance=Math.sqrt(squared);
          const overlap=minimum-distance,inv=.5*overlap/(distance||1);
          const delta=distance?[dx*inv,dy*inv,dz*inv]:[overlap*.5,0,0];
          for(let a=0;a<3;a++){p[a]-=delta[a];q[a]+=delta[a];}
          this.contact=Math.max(this.contact,overlap);
        }
      }
      for(let i=0;i<this.positions.length;i++){
        const p=this.positions[i],target=targets[i],distance=Math.hypot(...p.map((v,a)=>v-target[a]));
        if(distance>.25)for(let a=0;a<3;a++)p[a]=target[a]+(p[a]-target[a])*.25/distance;
        for(let a=0;a<3;a++){
          this.velocity[i][a]=(p[a]-previous[i][a])/h;
          this.activity=Math.max(this.activity,Math.abs(this.velocity[i][a]));
        }
      }
    }
  }
}
